export default __webpack_public_path__ + "static/media/kyc-level-waiting.1571a921.svg";